








import Component from 'vue-class-component';
import Vue from 'vue';

@Component({
	components: {},
	componentId: 'C012'
})
export default class LoadingSpinner extends Vue {}
